import { useContext, useState } from 'react';
import { apiPostRequest } from 'src/utils/mlPigeonAPIRequest';
import { ToastMessageContext } from 'src/context/toastMessageContext';

export const useTriggerWorkflow = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [response, setResponse] = useState<any>(null);
  const [error, setError] = useState<Error | null>(null);
  const { addToastMessage } = useContext(ToastMessageContext);

  const makeCall = (
    {
      startingOperatorType,
      startingOperatorName,
      variables,
      region,
      modelVersionId,
    }: {
      startingOperatorType: string;
      startingOperatorName: string;
      variables: { key: string; value: string }[];
      region: string;
      modelVersionId: string;
    },
    onClose: () => void,
  ) => {
    setLoading(true);
    const formattedVariables = variables.reduce(
      (prev: Record<string, string>, curr) => {
        prev[curr.key] = curr.value;
        return prev;
      },
      {},
    );
    const workflowTriggerDetails = {
      modelVersionId,
      startingOperatorType,
      startingOperatorName,
      variables: formattedVariables,
      region,
    };
    return apiPostRequest({
      endpoint: '/trigger/workflow',
      data: workflowTriggerDetails,
    })
      .then((res) => {
        setResponse(res);
        addToastMessage({
          header: 'Request Submitted Successfully',
          description: 'Request Submitted Successfully',
          type: 'success',
        });
      })
      .then(onClose)
      .catch((err) => {
        setError(err);
        addToastMessage({
          header: 'Error Sending Request',
          description: `There was an issue submitting your request. ${err.message}`,
          type: 'error',
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return [loading, error, response, makeCall];
};
